import * as Sentry from '@sentry/react';

/**
 * Initializes Sentry error tracking for the web application.
 * Only initializes if VITE_SENTRY_DSN is set; silently skips otherwise
 * so local development works without Sentry credentials.
 */
export const initSentry = (): void => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    // Send 100% of errors
    sampleRate: 1.0,
    // Enable source maps for better stack traces
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Capture 20% of transactions for performance monitoring
    tracesSampleRate: 0.2,
  });
};

export { Sentry };
